import Layout from "../../../components/Layout";
import PageTitle from "../../../components/PageTitle";
import Button from "../../../components/Button";
import { useEffect, useState } from "react";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import { TableSearch } from "../../../components/Table/TableActions";
import Table from "../../../components/Table/Table";
import { Icon } from "@iconify/react/dist/iconify.js";
import useValidator from "../../../hooks/useValidator";
import useStyles from "../styles";
import Modal from "../../../components/Modal";
import { Grid } from "@mui/material";
import InputGroup from "../../../components/FormComponent/InputGroup";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import PopModal from "../../../components/PopupModal/PopModal";
import useWindowSize from "../../../hooks/useWindow";
import PageLoader from "../../../components/PageLoader";

const OBTAINABLE_SCORE = "/api/v1/obtainable-score";
const GET_SESSIONS = "/api/v1/school-plan/session";

const ObtainableScore = () => {
  const classes = useStyles();
  const [obtainablescore, setObtainableScore] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchResult, setSearchResult] = useState([]);
  const [viewModal, setViewModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [activeSession, setActiveSession] = useState([]);
  const [currentRow, setCurrentRow] = useState({});
  const [allSessions, setAllSessions] = useState([]);
  const [isDeleting, setisDeleting] = useState(false);
  const [scoreValidator, showScoreValidator] = useValidator();
  const [scoreEDitValidator, showEditScoreValidator] = useValidator();
  const [bookError, setBookError] = useState("");
  const [editBookError, setEditBookError] = useState("");
  const [itemModal, setItemModal] = useState(false);
  const [scoreCreateLoading, setScoreCreateLoading] = useState(false);
  const [caform, setCaForm] = useState({
    session_id: "",
    examination: "",
    ca: [
      { ca_type: "", score: "" }
    ]
  });

  const [editcaform, setEditCaForm] = useState({
    ca: [
      {
        ca_type: "",
        score: ""
      }
    ],
    examination: ""
  });

  const handleCAChange = (index, field, value) => {
    const updatedCA = [...caform.ca];
    updatedCA[index][field] = value;

    const totalCA = updatedCA?.reduce((sum, item) => sum + Number(item?.score || 0), 0);
    const total = totalCA + Number(caform.examination || 0);

    if (total === 100) {
      setBookError("");
    } else {
      setBookError("All scores should sum up to 100");
    }

    setCaForm(prev => ({
      ...prev,
      ca: updatedCA
    }));
  };

  const AddAdditionalTestScore = () => {
    if (caform?.ca?.length > 0) {
      setCaForm(prev => ({
        ...prev,
        ca: [...prev.ca, { ca_type: "", score: "" }]
      }));
    }
  };

  const handleDeleteTestScore = (index) => {
    const updatedCA = caform.ca.filter((_, i) => i !== index);
    setCaForm(prev => ({
      ...prev,
      ca: updatedCA
    }));
  };

  const handleDeleteAnObtainable = (index) => {
    const myCA = [...(currentRow?.my_ca || [])];
    const toDelete = myCA[index];

    // eslint-disable-next-line no-undefined
    if (toDelete?.temporal_id === undefined) return;

    const temporalIdToRemove = toDelete.temporal_id;

    // Remove from editcaform.ca by temporal_id
    const updatedCA = (editcaform?.ca || []).filter(
      (item) => item.temporal_id !== temporalIdToRemove
    );

    // Remove from currentRow.my_ca visually
    const updatedMyCA = myCA.filter((item) => item.temporal_id !== temporalIdToRemove);

    setEditCaForm((prev) => ({
      ...prev,
      ca: updatedCA
    }));

    setCurrentRow((prev) => ({
      ...prev,
      my_ca: updatedMyCA
    }));
  };

  /**
 * Custom hook to get window size
 * @type {WindowSizeHook}
 */
  const width = useWindowSize();
  /**
 * Boolean indicating if the screen is mobile size (width < 600px)
 * @type {boolean}
 */
  const mobile = width < 600;

  /**
 * Handles closing the delete confirmation modal
 */
  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
  };

  /**
 * Toggles the delete confirmation modal and sets the current row
 * @param {ObtainableScore} row - The score row to be deleted
 */
  const handleDeleteModal = (row) => {
    setCurrentRow(row);
    setDeleteModal(!deleteModal);
  };

  /**
 * Toggles the view modal and sets the current row
 * @param {ObtainableScore} row - The score row to view
 */
  const handleViewModal = (row) => {
    setCurrentRow(row);
    setViewModal(!viewModal);
  };

  /**
 * Toggles the edit modal and sets the current row with its values
 * @param {ObtainableScore} row - The score row to edit
 */
  const handleEditModal = (row) => {
    setCurrentRow(row);

    const validCaTypes = row?.ca?.map((item) => item.ca_type) ?? [];

    setEditCaForm({
      examination: row?.examination ?? "",
      ca: row?.my_ca
        ?.filter((item) => validCaTypes.includes(item.ca_type))
        .map((item) => ({
          temporal_id: item.temporal_id,
          ca_type: item.ca_type,
          score: item.score
        })) ?? []
    });

    setEditModal(!editModal);
    setEditBookError("");
  };

  /**
 * Fetches all available sessions from the API
 * @async
 * @function
 */
  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
      const foundSession = res?.data?.data?.find((session) => session?.current_session === true);
      setActiveSession(foundSession);
      setCaForm((prevCaForm) => ({ ...prevCaForm, session_id: foundSession?.id }));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  /**
 * Fetches all obtainable scores from the API
 */
  const getAllObtainableScores = () => {
    setIsLoading(true);
    httprequest
      .get(OBTAINABLE_SCORE)
      .then((res) => {
        setObtainableScore(res?.data?.data);
        setSearchResult(res?.data?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  /**
 * Toggles the item creation modal
 */
  const handleOpenItemMOdal = () => {
    setItemModal(!itemModal);
  };

  /**
 * Closes the creation modal and resets the form
 */
  const handleCloseCreateModal = () => {
    setItemModal(false);
    setCaForm({
      session_id: activeSession?.id || "",
      examination: "",
      ca: [
        { ca_type: "", score: "" }
      ]
    });
  };

  /**
 * Closes the edit modal and resets the edit form
 */
  const handleCloseEditModal = () => {
    setEditModal(false);
    setEditCaForm({ session_id: "", CA1: "", CA2: "", examination: "" });
  };

  /**
 * Handles creating a new obtainable score
 */
  const handleCreateScore = () => {
    if (bookError) {
      toast.error("Please ensure the total score is 100 before proceeding.");

      return;
    }

    if (scoreValidator.allValid()) {
      setScoreCreateLoading(true);
      httprequest
        .post(OBTAINABLE_SCORE, caform)
        .then((res) => {
          setScoreCreateLoading(false);
          toast.success(res?.data?.message || "SCore created successfully");
          getAllObtainableScores();
          handleCloseCreateModal();
        })
        .catch((err) => {
          setScoreCreateLoading(false);
          toast.error(err?.response?.data?.message || "An error occurred");
        });
    } else {
      showScoreValidator(true);
    }
  };

  const AddAdditionalEditTestScore = () => {
    const currentMyCA = currentRow?.my_ca || [];

    // Get the next temporal_id (increment from the last one)
    const nextId =
    currentMyCA.length > 0
      ? Math.max(...currentMyCA.map((item) => item.temporal_id ?? -1)) + 1
      : 0;

    const newEntry = {
      temporal_id: nextId,
      ca_type: "",
      score: 0
    };

    // Update editcaform
    setEditCaForm((prev) => ({
      ...prev,
      ca: [...(prev?.ca || []), newEntry]
    }));

    // Update currentRow (visual)
    setCurrentRow((prev) => ({
      ...prev,
      my_ca: [...(prev?.my_ca || []), newEntry]
    }));
  };

  /**
 * Handles editing an existing obtainable score
 */
  const handleEDitScore = () => {
    if (editBookError) {
      toast.error("Please ensure the total score is 100 before proceeding.");

      return;
    }

    if (scoreEDitValidator.allValid()) {
      setEditLoading(true);

      // Clone and remove temporal_id from each CA item
      const cleanCA = (editcaform?.ca || []).map((item) => {
        const cleanItem = { ...item };
        delete cleanItem?.temporal_id;

        return cleanItem;
      });

      const payload = {
        ...editcaform,
        ca: cleanCA
      };

      httprequest
        .patch(`${OBTAINABLE_SCORE}/${currentRow?.id}`, payload)
        .then((res) => {
          setEditLoading(false);
          toast.success(res?.data?.message || "Score updated successfully");
          getAllObtainableScores();
          handleCloseEditModal();
        })
        .catch((err) => {
          setEditLoading(false);
          toast.error(err?.response?.data?.message || "An error occurred");
        });
    } else {
      showEditScoreValidator(true);
    }
  };

  /**
 * Handles form input changes for creation form and validates total score
 * @function
 * @param {Object} e - The event object
 * @param {Object} e.target - The target input element
 * @param {string} e.target.name - The name of the input field
 * @param {string} e.target.value - The value of the input field
 */
  const handleChange = (e) => {
    const { name, value } = e.target;

    const updatedForm = { ...caform, [name]: value };

    // Sum CA scores
    const totalCA = caform?.ca?.reduce((sum, item) => sum + Number(item?.score || 0), 0);
    const total = totalCA + Number(value || 0);

    if (name === "examination") {
      if (total === 100) {
        setBookError("");
      } else {
        setBookError("All scores should sum up to 100");
      }
    }

    setCaForm(updatedForm);
  };

  /**
 * Handles form input changes for edit form and validates total score
 * @function
 * @param {Object} e - The event object
 * @param {Object} e.target - The target input element
 * @param {string} e.target.name - The name of the input field
 * @param {string} e.target.value - The value of the input field
 */

  const handleEDitChange = (indexOrEvent, field, valueParam) => {
  // Handle if triggered by exam input change
    if (field === "examination") {
      const value = valueParam === "" ? "" : Number(valueParam);

      const updatedCA = [...(editcaform?.ca || [])];

      // Calculate total
      const totalCA = updatedCA.reduce((sum, item) => {
        const score = Number(item?.score);

        return isNaN(score) ? sum : sum + score;
      }, 0);
      const total = totalCA + (Number(value) || 0);

      if (total === 100) {
        setEditBookError("");
      } else {
        setEditBookError("All scores should sum up to 100");
      }

      setEditCaForm((prev) => ({
        ...prev,
        examination: value
      }));

      setCurrentRow((prev) => ({
        ...prev,
        examination: value
      }));

      return;
    }

    // Otherwise, update my_ca scores
    const index = indexOrEvent;
    const value = valueParam;
    const updatedMyCA = [...(currentRow?.my_ca || [])];
    if (!updatedMyCA[index]) return;

    const updatedValue =
    field === "score"
      ? value === "" ? "" : Number(value)
      : value;

    updatedMyCA[index] = {
      ...updatedMyCA[index],
      [field]: updatedValue
    };

    const temporal_id = updatedMyCA[index].temporal_id;

    const updatedCA = [...(editcaform?.ca || [])];
    const existingIndex = updatedCA.findIndex((ca) => ca.temporal_id === temporal_id);

    if (existingIndex !== -1) {
      updatedCA[existingIndex] = {
        ...updatedCA[existingIndex],
        [field]: updatedValue
      };
    } else {
      updatedCA.push({
        temporal_id,
        ca_type: updatedMyCA[index].ca_type,
        score:
        field === "score"
          ? value === "" ? "" : Number(value)
          : Number(updatedMyCA[index].score) || 0
      });
    }

    const totalCA = updatedCA.reduce((sum, item) => {
      const score = Number(item?.score);

      return isNaN(score) ? sum : sum + score;
    }, 0);
    const total = totalCA + Number(editcaform?.examination || 0);

    if (total === 100) {
      setEditBookError("");
    } else {
      setEditBookError("All scores should sum up to 100");
    }

    setCurrentRow((prev) => ({
      ...prev,
      my_ca: updatedMyCA
    }));

    setEditCaForm((prev) => ({
      ...prev,
      ca: updatedCA
    }));
  };

  /**
 * Handles deleting an obtainable score
 */
  const handleDeleteObtainableScore = () => {
    setisDeleting(true);
    httprequest
      .delete(`${OBTAINABLE_SCORE}/${currentRow?.id}`)
      .then((res) => {
        setisDeleting(false);
        toast.success(res?.data?.message);
        handleCloseDeleteModal();
        getAllObtainableScores();
      })
      .catch((err) => {
        setisDeleting(false);
        toast.error(err?.response?.data?.message);
      });
  };

  /**
 * Fetches initial data on component mount
 */
  useEffect(() => {
    getAllSessions();
    getAllObtainableScores();
  }, []);

  const getAllCATypes = (data) => {
    const caTypeSet = new Set();

    data.forEach((entry) => {
      entry.ca?.forEach((ca) => {
        if (ca?.ca_type) {
          caTypeSet.add(ca.ca_type);
        }
      });
    });

    return Array.from(caTypeSet);
  };

  const normalizeDataWithMyCA = (data, caTypes) => {
    return data?.map((entry) => {
      const my_ca = caTypes?.map((type, index) => {
        const found = entry?.ca?.find((ca) => ca?.ca_type === type);

        return {
          temporal_id: index,
          ca_type: type,
          score: found?.score ?? "N/A"
        };
      });

      return {
        ...entry,
        my_ca
      };
    });
  };

  const buildMyCACustomColumns = (caTypes) => caTypes?.map((type) => ({
    name: type,
    selector: (row) => {
      const item = row?.my_ca?.find((ca) => ca?.ca_type === type);

      return (
        <>
          {mobile && <p className="mobile-styling">{type}</p>}
          {item?.score ?? "N/A"}
        </>
      );
    }
  }));

  const caTypes = getAllCATypes(searchResult);
  const normalizedData = normalizeDataWithMyCA(searchResult, caTypes);
  const caColumns = buildMyCACustomColumns(caTypes);

  /**
 * Table columns configuration
 * @type {Array<Object>}
 */
  const columns = [
    {
      name: "Session",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Session</p>}
          {row?.session?.session || "--/--"}
        </>
      )
    },
    {
      name: "Examination",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Examination</p>}
          {row?.examination || "--/--"}
        </>
      )
    },
    ...caColumns,
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button className="table-action-icon"
            onClick={() => handleViewModal(row)}
          >
            <Icon icon="fluent:eye-16-regular" />
          </button>
          <button className="table-action-icon"
            onClick={() => handleEditModal(row)}
          >
            <Icon icon="heroicons:pencil-square-solid" />
          </button>
          <button
            className="table-action-icon delete-icon"
            onClick={() => handleDeleteModal(row)}
          >
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }
  ];

  /**
 * Handles searching/filtering the obtainable scores table
 * @function
 * @param {Object} e - The event object
 * @param {Object} e.target - The target input element
 * @param {string} e.target.value - The search query value
 */
  const handleSearchNotice = (e) => {
    const { value } = e.target;
    const valArray = value.split(" ");

    const result = obtainablescore?.filter((data) => valArray?.every((word) => {
      const lowerWord = word.toLowerCase();

      const ca1 = data?.ca?.find((c) => c.ca_type?.toLowerCase() === "ca1")?.score?.toString() || "";
      const ca2 = data?.ca?.find((c) => c.ca_type?.toLowerCase() === "ca2")?.score?.toString() || "";

      return (
        ca1.toLowerCase().includes(lowerWord) ||
        ca2.toLowerCase().includes(lowerWord) ||
        data?.examination?.toString().toLowerCase().includes(lowerWord) ||
        data?.session?.session?.toLowerCase().includes(lowerWord)
      );
    })
    );

    setSearchResult(result);
  };

  return (
    <Layout
      children={
        <>
          <PageTitle
            title="Set Obtainable Score"
            subtitle="create and view all obtainable score in your school."
            button={
              <div className="flex gap-10">
                <PopModal videoUrl="https://youtu.be/53EwJIDCLMo" title="Obtainable Score" />
                <Button
                  variant="primary"
                  buttonSize="fluid"
                  color="btndefault"
                  onClick={handleOpenItemMOdal}
                  buttonName="Set Obtainable Score"
                />
              </div>
            }
          />
          <div className="page-content">
            {isLoading ? (
              <PageLoader />
            ) : (
              <Table
                data={normalizedData}
                columns={columns}
                subHeader={true}
                subHeaderComponent={
                  <TableSearch
                    placeholder="Search here..."
                    searchTableFunc={handleSearchNotice}
                  />}
                pagination
              />
            )}
          </div>
          {/* Create an Obtainable Score */}
          <Modal
            title="Set Obtainable Score"
            subtitle={
              <div>
                You can set the obtainable score for CA and Exam
              </div>
            }
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup
                      label="Session"
                      required
                      children={
                        <select defaultValue={activeSession?.id} name="session_id" onChange={handleChange}>
                          <option value="">--- Select ---</option>
                          {allSessions?.map((sesh) => {
                            return (
                              <option key={sesh.id} value={sesh?.id}>
                                {sesh?.session}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                    {scoreValidator.message("Session", caform?.session_id, "required")}
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    {caform?.ca?.map((item, index) => (
                      <Grid container spacing={2} className="input-padding" key={index}>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <InputGroup
                            label={`Assessment Title (E.g CA ${index + 1})`}
                            margin="normal"
                            inputType="text"
                            required
                            inputName={`ca_type_${index}`}
                            value={item.ca_type}
                            onChange={(e) => handleCAChange(index, "ca_type", e.target.value)}
                          />
                          {scoreValidator.message(`CA Type ${index + 1}`, item?.ca_type, "required")}
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <InputGroup
                            label="Assessment Score"
                            margin="normal"
                            inputType="number"
                            required
                            inputName={`score_${index}`}
                            value={item.score}
                            onChange={(e) => handleCAChange(index, "score", e.target.value)}
                          />
                          {scoreValidator.message(`CA Score ${index + 1}`, item?.score, "required")}
                        </Grid>

                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          {caform?.ca?.length > 1 && (
                            <p
                              className="delete-input"
                              onClick={() => handleDeleteTestScore(index)}
                            >
                              <Icon icon="zondicons:minus-solid" />
        Remove this CA
                            </p>
                          )}
                        </Grid>
                      </Grid>
                    ))}

                    {caform?.ca?.length > 0 && (
                      <div
                        className={`${classes.item} flex gap-5 align-items-center`}
                        onClick={AddAdditionalTestScore}
                      >
                        <Icon icon="octicon:feed-plus-16" width="12" height="12" />
                        <p>Add another CA</p>
                      </div>
                    )}
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Examination"
                      margin="normal"
                      inputType="text"
                      required
                      inputName="examination"
                      onChange={handleChange}
                    />
                    {scoreValidator.message("Examination", caform?.examination, "required")}
                    {bookError && <p className="text-danger">{bookError}</p>}

                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <div className={classes.modalFooterBtn}>
                  <Button
                    variant="primaryoutline"
                    buttonSize="full"
                    color="btnfontprimary"
                    buttonName="Cancel"
                    onClick={handleOpenItemMOdal}
                    //   isLoading={resultCreating}
                  />
                  <Button
                    variant="primary"
                    buttonSize="full"
                    color="btndefault"
                    buttonName="Save Obtainable Score"
                    onClick={handleCreateScore}
                    isLoading={scoreCreateLoading}
                  />
                </div>
              </>
            }
            isopen={itemModal}
            closeModal={handleCloseCreateModal}
          />
          {/* View an Obtainable Score */}
          <Modal
            title={`Obtainable Score set for ${currentRow?.session?.session}`}
            subtitle={
              <div>
                View set the obtainable score for CA and Exam
              </div>
            }
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup
                      label="Session"
                      required
                      children={
                        <select disabled defaultValue={currentRow?.session?.id} name="session_id" onChange={handleChange}>
                          <option value="">--- Select ---</option>
                          {allSessions?.map((sesh) => {
                            return (
                              <option key={sesh.id} value={sesh?.id}>
                                {sesh?.session}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    {currentRow?.my_ca?.map((item, index) => (
                      <Grid container spacing={2} className="input-padding" key={index}>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <InputGroup
                            label={`Assessment Title (E.g CA ${index + 1})`}
                            margin="normal"
                            inputType="text"
                            required
                            disabled
                            inputName={`ca_type_${index}`}
                            defaultValue={item.ca_type}
                          />
                        </Grid>

                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <InputGroup
                            label="Assessment Score"
                            margin="normal"
                            inputType="number"
                            required
                            disabled
                            inputName={`score_${index}`}
                            defaultValue={item?.score || "N/A"}
                          />
                        </Grid>
                      </Grid>
                    ))}
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Examination"
                      margin="normal"
                      inputType="text"
                      required
                      disabled
                      defaultValue={currentRow?.examination}
                      inputName="examination"
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
              </>
            }
            isopen={viewModal}
            closeModal={handleViewModal}
          />
          {/* Edit an Obtainable Score */}
          <Modal
            title={`Edit Obtainable Score set for ${currentRow?.session?.session}`}
            subtitle={
              <div>
                Edit obtainable score for CA and Exam
              </div>
            }
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup
                      label="Session"
                      required
                      children={
                        <select disabled defaultValue={currentRow?.session?.id} name="session_id" onChange={handleEDitChange}>
                          <option value="">--- Select ---</option>
                          {allSessions?.map((sesh) => {
                            return (
                              <option key={sesh.id} value={sesh?.id}>
                                {sesh?.session}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                    {/* {scoreEDitValidator.message("Session", editcaform?.session_id, "required")} */}
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    {currentRow?.my_ca?.map((item, index) => (
                      <Grid container spacing={2} className="input-padding" key={index}>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <InputGroup
                            label={`Assessment Title (E.g CA ${index + 1})`}
                            margin="normal"
                            inputType="text"
                            required
                            inputName={`ca_type_${index}`}
                            value={item.ca_type}
                            onChange={(e) => handleEDitChange(index, "ca_type", e.target.value)}
                          />
                          {scoreEDitValidator.message(`Edit CA Type ${index + 1}`, item?.ca_type, "required")}
                        </Grid>

                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <InputGroup
                            label="Assessment Score"
                            margin="normal"
                            inputType="number"
                            required
                            inputMin={0}
                            inputName={`score_${index}`}
                            value={item.score}
                            onChange={(e) => handleEDitChange(index, "score", e.target.value)}
                          />
                          {scoreEDitValidator.message(`Edit CA Score ${index + 1}`, item?.score, "required")}
                        </Grid>

                        {currentRow?.my_ca?.length > 1 && (
                          <Grid item lg={6} md={6} sm={12} xs={12}>
                            <p className="delete-input" onClick={() => handleDeleteAnObtainable(index)}>
                              <Icon icon="zondicons:minus-solid" />
          Remove this CA
                            </p>
                          </Grid>
                        )}
                      </Grid>
                    ))}
                    {currentRow?.my_ca?.length > 0 && (
                      <div
                        className={`${classes.item} flex gap-5 align-items-center`}
                        onClick={AddAdditionalEditTestScore}
                      >
                        <Icon icon="octicon:feed-plus-16" width="12" height="12" />
                        <p>Add another CA</p>
                      </div>
                    )}

                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Examination"
                      margin="normal"
                      inputType="number"
                      required
                      defaultValue={currentRow?.examination}
                      inputName="examination"
                      onChange={(e) => handleEDitChange(null, "examination", e.target.value)}
                    />
                    {scoreEDitValidator.message("Examination", editcaform?.examination, "required")}
                    {editBookError && <p className="text-danger">{editBookError}</p>}

                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <div className={classes.modalFooterBtn}>
                  {/* <Button
                    variant="primaryoutline"
                    buttonSize="full"
                    color="btnfontprimary"
                    buttonName="Cancel"
                    onClick={handleCloseEditModal}
                    //   isLoading={resultCreating}
                  /> */}
                  <Button
                    variant="primary"
                    buttonSize="full"
                    color="btndefault"
                    buttonName="Edit Obtainable Score"
                    onClick={handleEDitScore}
                    isLoading={editLoading}
                  />
                </div>
              </>
            }
            isopen={editModal}
            closeModal={handleEditModal}
          />
          {/* Delete Modal */}
          <Modal
            title="Delete An Obtainable Score"
            subtitle={
              <div>
                Are you sure you want to remove{" "}
                <span className="modal-name-highlight">
                  {currentRow?.session?.session}{" "}
                </span>
                Obtainable Score from one of your Obtainable Scores, Removing it will permanently
                delete it.
              </div>
            }
            modalContent={<></>}
            modalFooter={
              <>
                <div className="flex gap-10">
                  {/* <Button
                    variant="dangeroutline"
                    buttonSize="full"
                    color="btndanger"
                    buttonName="Cancel"
                    onClick={handleCloseDeleteModal}
                  /> */}
                  <Button
                    variant="danger"
                    buttonName="Remove Obtainable Score"
                    buttonSize="full"
                    color="btndefault"
                    onClick={handleDeleteObtainableScore}
                    isLoading={isDeleting}
                  />
                </div>
              </>
            }
            isopen={deleteModal}
            closeModal={handleCloseDeleteModal}
          />
          {/* <ToastContainer /> */}
        </>
      }
    />
  );
};

export default ObtainableScore;
